module.exports = __webpack_public_path__ + "8d4d9c292294c3cc95e458feafaa9051.png";


//////////////////
// WEBPACK FOOTER
// ../assets/screenshots/simone/simone-simulate.png
// module id = 545
// module chunks = 0